import React, {useContext} from 'react';
import './ProfileNavigation.less';

import {NavigationItem} from '../navigation-item/NavigationItem';
import ProfileIcon from 'new-images/profile.svg';
import SettingsIcon from 'new-images/settings.svg';
import {IconBadgeColors} from "elements/icon-badge/IconBadge";
import {useMediaQuery} from "react-responsive";
import {largeScreenMediaQuery} from "new-constants/common.constants";
import {TranslationsContext} from "contexts/translations-context";
import {getSafeTranslation} from "helpers/localization.helper.ts";

import {ListItem} from "elements/list-item/ListItem";
import {List} from "elements/list/List";

import Platform from '../../../platform';
import AddIcon from '../../../images/add.svg';
import DownloadIcon from '../../../images/download.svg';


export const ProfileNavigation = ({onProfileClick, isShowAddToHomeScreen, onAddToHomeScreenClick, onSettingsClick}) => {

	const isLargeScreen = useMediaQuery({query: largeScreenMediaQuery});

	const translations = useContext(TranslationsContext);

	return (
		<List isModal>
			<ListItem onClick={onProfileClick} key="edit-profile">
				<NavigationItem
					name={getSafeTranslation('ProfileNavigation.editProfileLabel', translations)}
					icon={ProfileIcon}
					iconColor={isLargeScreen ? IconBadgeColors.normal : IconBadgeColors.dark}
				/>
			</ListItem>
			{
				isShowAddToHomeScreen && (
					<ListItem onClick={onAddToHomeScreenClick} key="add-to-home-screen">
						<NavigationItem
							name={getSafeTranslation('ProfileNavigation.installButtonCaption', translations)}
							icon={Platform.isAndroid ? DownloadIcon : AddIcon}
							iconColor={isLargeScreen ? IconBadgeColors.normal : IconBadgeColors.dark}
						/>
					</ListItem>
				)
			}
			<ListItem onClick={onSettingsClick} key="settings">
				<NavigationItem
					name={getSafeTranslation('ProfileNavigation.settingsLabel', translations)}
					icon={SettingsIcon}
					iconColor={isLargeScreen ? IconBadgeColors.normal : IconBadgeColors.dark}
				/>
			</ListItem>
		</List>
	);
};
